var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.705 6.97589L12.2961 5.77151L14.705 4.56701C15.1358 4.35164 15.1363 3.73457 14.705 3.51885L7.79086 0.0617984C7.62583 -0.0205995 7.43174 -0.0205995 7.26672 0.0617984L0.352623 3.51885C-0.0782494 3.73434 -0.0787072 4.35141 0.352623 4.56701L2.7615 5.77151L0.352623 6.97589C-0.0782494 7.19138 -0.0787072 7.80834 0.352623 8.02406L2.7615 9.22856L0.352623 10.4329C-0.0782494 10.6484 -0.0787072 11.2654 0.352623 11.4811L7.26672 14.9382C7.4314 15.0204 7.62549 15.0208 7.79086 14.9382L14.705 11.4811C15.1358 11.2656 15.1363 10.6487 14.705 10.4329L12.2961 9.22856L14.705 8.02406C15.1358 7.80868 15.1363 7.19161 14.705 6.97589ZM7.52879 1.241L13.1326 4.04299L7.52879 6.84486L1.92493 4.04299L7.52879 1.241ZM13.1326 10.9571L7.52879 13.7589L1.92493 10.9571L4.07174 9.88362L7.26672 11.4811C7.43151 11.5634 7.62549 11.5637 7.79086 11.4811L10.9858 9.88362L13.1326 10.9571ZM7.52879 10.3019L1.92493 7.50003L4.07174 6.42657L7.26672 8.02406C7.43151 8.10634 7.62549 8.10669 7.79086 8.02406L10.9858 6.42657L13.1326 7.50003L7.52879 10.3019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.29fa0050d7d1cc670b42c5140bafd95a.svg";
export { ForwardRef as ReactComponent };